module.exports = __webpack_public_path__ + "img/9788952239310.67ce8a29.jpg";